// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__Ceyhb","Tooltip__arrow":"Tooltip_Tooltip__arrow__onR6H"};